import React, { Fragment, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import * as Yup from "yup";
import CustomInput from "../../../Custom/CustomInput";
import { Field, FormikProvider, useFormik } from "formik";
import { Col, Form, InputGroup, Label, Row } from "reactstrap";
import CustomSelect from "../../../Custom/CustomSelect";
import CustomFlatpickr from "../../../Custom/CustomFlatpicker";
import { Modal, Button } from "react-bootstrap";
import swal from "sweetalert";
import { t } from "i18next";
import { Spin } from "antd";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const AddPackageSchedule = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [selectTime, setSelectTime] = useState(new Date());
  const [patientDetailModel, setPatientDetailModal] = useState(false);
  const [orderDetailModal, setOrderDetailModal] = useState(false);

  const validationSchema = Yup.object().shape({});

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {},
    validateOnBlur: false,
  });
  const {
    setValues,
    setFieldValue,
    handleValidSubmit,
    values: {},
  } = formik;

  const optionServiceHours = [
    { label: "2 Hours", value: 1 },
    { label: "4 Hours", value: 2 },
    { label: "6 Hours", value: 3 },
    { label: "8 Hours", value: 4 },
  ];

  const optionStaff = [
    { label: "Yana T. Suthar - +91 96388 99115", value: 1 },
    { label: "Hitesh P. Vaghela - +91 90332 31046", value: 2 },
    { label: "Nirav J. Savaliya - +91 96385 14562", value: 3 },
  ];

  return (
    <Fragment>
      <Spin size="large" spinning={isLoading} tip={"Loading..."}>
        <PageTitle
          activeMenu="Package Schedule"
          motherMenu={
            <Link to="/schedule-package-and-healthcheckup">
              Schedule Package & Health Checkup
            </Link>
          }
        />
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="basic-form">
                  <FormikProvider value={formik}>
                    <Form onSubmit={formik.handleSubmit}>
                      <Row>
                        <Col lg={6}>
                          <Row>
                            <Col lg={4}>
                              <b>Order No.</b>
                            </Col>
                            <Col lg={1}>:</Col>
                            <Col lg={7}>AMDOD00002</Col>
                          </Row>
                        </Col>
                        <Col lg={6}>
                          <Row>
                            <Col lg={4}>
                              <b>Patient Name</b>
                            </Col>
                            <Col lg={1}>:</Col>
                            <Col lg={7}>Yana Suthar</Col>
                          </Row>
                        </Col>
                        <Col lg={6}>
                          <Row>
                            <Col lg={4}>
                              <b>Patient No.</b>
                            </Col>
                            <Col lg={1}>:</Col>
                            <Col lg={7}>PT00000001</Col>
                          </Row>
                        </Col>

                        <Col lg={6}>
                          <Row>
                            <Col lg={4}>
                              <b>Mobile No.</b>
                            </Col>
                            <Col lg={1}>:</Col>
                            <Col lg={7}>9638869115</Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12} style={{ textAlign: "end" }}>
                          <div
                            onClick={() => {
                              setOrderDetailModal(true);
                            }}
                            className="btn btn-light btn-xxs btn-rounded mt-4"
                          >
                            Order Detail
                          </div>
                          &nbsp;&nbsp;
                          <div
                            onClick={() => {
                              setPatientDetailModal(true);
                            }}
                            className="btn btn-light btn-xxs btn-rounded mt-4"
                          >
                            Patient Detail
                          </div>
                        </Col>
                      </Row>
                      <hr></hr>
                      <Row className="mt-3">
                        <Col lg={6}>
                          <Row>
                            <Col lg={4}>
                              <h6>
                                <b>Package Name</b>
                              </h6>
                            </Col>
                            <Col lg={1}>:</Col>
                            <Col lg={7}>Pre Knee & Hip Replacment Package</Col>
                          </Row>
                        </Col>
                        <Col lg={6}>
                          <Row>
                            <Col lg={4}>
                              <h6>
                                <b>Package Duration</b>
                              </h6>
                            </Col>
                            <Col lg={1}>:</Col>
                            <Col lg={7}>20 Days</Col>
                          </Row>
                        </Col>
                      </Row>
                      <hr></hr>
                      <h6 className="mb-3">Package Inclusion Services</h6>
                      <Row className="mt-3">
                        <Col lg={4}>
                          <Field
                            label={"Service Name"}
                            name="ServiceName"
                            placeholder={"Select Service Name"}
                            // options={optionService}
                            component={CustomInput}
                            value={"Dressing"}
                            style={{ background: "#e9ecef" }}
                            disabled={true}
                            required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            type="number"
                            label={"Quantity"}
                            name="Quantity"
                            placeholder={"Enter Quantity"}
                            component={CustomInput}
                            value={"4"}
                            disabled={true}
                            min={0}
                            required
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={2}>
                          <Field
                            label={"Service Date"}
                            name="ServiceDate"
                            placeholder={"Service Date"}
                            component={CustomFlatpickr}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Label>
                            Time
                            <span className="text-danger">*</span>
                          </Label>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <TimePicker
                              autoOk
                              name={"Time"}
                              placeholder={"Select Start Time"}
                              value={selectTime}
                              ampmInClock={true}
                              onChange={setSelectTime}
                              // minutesStep={0}
                              // format={"h:00 a"}
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col lg={4}>
                          <Field
                            label={"Service Hours"}
                            name="ServiceHours"
                            placeholder={"Select Service Hours"}
                            options={optionServiceHours}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            label={"Staff Name"}
                            name="StaffName"
                            placeholder={"Select Staff Name"}
                            options={optionStaff}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={2}>
                          <Field
                            label={"Service Date"}
                            name="ServiceDate"
                            placeholder={"Service Date"}
                            component={CustomFlatpickr}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Label>
                            Time
                            <span className="text-danger">*</span>
                          </Label>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <TimePicker
                              autoOk
                              name={"Time"}
                              placeholder={"Select Start Time"}
                              value={selectTime}
                              ampmInClock={true}
                              onChange={setSelectTime}
                              // minutesStep={0}
                              // format={"h:00 a"}
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col lg={4}>
                          <Field
                            label={"Service Hours"}
                            name="ServiceHours"
                            placeholder={"Select Service Hours"}
                            options={optionServiceHours}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            label={"Staff Name"}
                            name="StaffName"
                            placeholder={"Select Staff Name"}
                            options={optionStaff}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={2}>
                          <Field
                            label={"Service Date"}
                            name="ServiceDate"
                            placeholder={"Service Date"}
                            component={CustomFlatpickr}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Label>
                            Time
                            <span className="text-danger">*</span>
                          </Label>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <TimePicker
                              autoOk
                              name={"Time"}
                              placeholder={"Select Start Time"}
                              value={selectTime}
                              ampmInClock={true}
                              onChange={setSelectTime}
                              // minutesStep={0}
                              // format={"h:00 a"}
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col lg={4}>
                          <Field
                            label={"Service Hours"}
                            name="ServiceHours"
                            placeholder={"Select Service Hours"}
                            options={optionServiceHours}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            label={"Staff Name"}
                            name="StaffName"
                            placeholder={"Select Staff Name"}
                            options={optionStaff}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={2}>
                          <Field
                            label={"Service Date"}
                            name="ServiceDate"
                            placeholder={"Service Date"}
                            component={CustomFlatpickr}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Label>
                            Time
                            <span className="text-danger">*</span>
                          </Label>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <TimePicker
                              autoOk
                              name={"Time"}
                              placeholder={"Select Start Time"}
                              value={selectTime}
                              ampmInClock={true}
                              onChange={setSelectTime}
                              // minutesStep={0}
                              // format={"h:00 a"}
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col lg={4}>
                          <Field
                            label={"Service Hours"}
                            name="ServiceHours"
                            placeholder={"Select Service Hours"}
                            options={optionServiceHours}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            label={"Staff Name"}
                            name="StaffName"
                            placeholder={"Select Staff Name"}
                            options={optionStaff}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={4}>
                          <Field
                            label={"Service Name"}
                            name="ServiceName"
                            placeholder={"Select Service Name"}
                            // options={optionService}
                            component={CustomInput}
                            value={"Care Giver"}
                            style={{ background: "#e9ecef" }}
                            disabled={true}
                            required
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            type="number"
                            label={"Quantity"}
                            name="Quantity"
                            placeholder={"Enter Quantity"}
                            component={CustomInput}
                            value={"20"}
                            disabled={true}
                            min={0}
                            required
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={2}>
                          <Field
                            label={"From Date"}
                            name="FromDate"
                            placeholder={"From Date"}
                            component={CustomFlatpickr}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label={"To Date"}
                            name="ToDate"
                            placeholder={"To Date"}
                            component={CustomFlatpickr}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Label>
                            Time
                            <span className="text-danger">*</span>
                          </Label>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <TimePicker
                              autoOk
                              name={"Time"}
                              placeholder={"Select Start Time"}
                              value={selectTime}
                              ampmInClock={true}
                              onChange={setSelectTime}
                              // minutesStep={0}
                              // format={"h:00 a"}
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col lg={3}>
                          <Field
                            label={"Service Hours"}
                            name="ServiceHours"
                            placeholder={"Select Service Hours"}
                            options={optionServiceHours}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label={"Staff Name"}
                            name="StaffName"
                            placeholder={"Select Staff Name"}
                            options={optionStaff}
                            component={CustomSelect}
                            required
                          />
                        </Col>
                      </Row>
                      <hr></hr>
                      <h6 className="mb-3">Package Inclusion Equipment</h6>
                      <Row className="mt-3">
                        <Col lg={4}>
                          <Field
                            label={"Equipment Name"}
                            name="EquipmentName"
                            placeholder={"Enter Equipment Name"}
                            // options={optionService}
                            component={CustomInput}
                            value={"Blood Bag"}
                            style={{ background: "#e9ecef" }}
                            disabled={true}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            type="number"
                            label={"Quantity"}
                            name="EquipmentQuantity"
                            placeholder={"Enter Quantity"}
                            component={CustomInput}
                            value={"2"}
                            disabled={true}
                            min={0}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label={"From Date"}
                            name="EquipmentFromDate"
                            placeholder={"From Date"}
                            component={CustomFlatpickr}
                            required
                          />
                        </Col>

                        {/* <Col lg={2}>
                          <Field
                            type="number"
                            label={"Days"}
                            name="EquipmentDays"
                            placeholder={"Enter Days"}
                            component={CustomInput}
                            min={0}
                            required
                          />
                        </Col> */}
                      </Row>
                      <Row>
                        <Col lg={4}>
                          <Field
                            label={"Equipment Name"}
                            name="EquipmentName"
                            placeholder={"Enter Equipment Name"}
                            // options={optionService}
                            component={CustomInput}
                            value={"Wheelchair"}
                            style={{ background: "#e9ecef" }}
                            disabled={true}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            type="number"
                            label={"Quantity"}
                            name="EquipmentQuantity"
                            placeholder={"Enter Quantity"}
                            component={CustomInput}
                            value={"1"}
                            disabled={true}
                            min={0}
                            required
                          />
                        </Col>
                        <Col lg={2}>
                          <Field
                            label={"From Date"}
                            name="EquipmentFromDate"
                            placeholder={"From Date"}
                            component={CustomFlatpickr}
                            required
                          />
                        </Col>

                        {/* <Col lg={2}>
                          <Field
                            type="number"
                            label={"Days"}
                            name="EquipmentDays"
                            placeholder={"Enter Days"}
                            component={CustomInput}
                            min={0}
                            required
                          />
                        </Col> */}
                      </Row>

                      <hr></hr>
                      <Row className="mt-3">
                        <Col>
                          <button type="submit" className="btn btn-primary">
                            Save
                          </button>{" "}
                          <button
                            type="button"
                            onClick={(e) => {
                              history.goBack();
                            }}
                            className="btn btn-light"
                          >
                            {" "}
                            <i className="flaticon-delete-1"></i> Cancel
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          className="modal fade"
          show={orderDetailModal}
          onHide={setOrderDetailModal}
          size="xl"
        >
          <div className="modal-header">
            <h4 className="modal-title fs-20">Order Detail</h4>
            <button
              type="button"
              className="btn close"
              onClick={() => setOrderDetailModal(false)}
            >
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <Row>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Patient No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>PT00000001</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Order No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>AMDOD00002</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Patient Name</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>Yana Suthar</Col>
                </Row>
              </Col>

              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Booking Order Date</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>17/Feb/2023</Col>
                </Row>
              </Col>

              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Patient Address</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5} style={{ textAlign: "left" }}>
                    A-910, Titanium City Center, Prahlad Nagar
                  </Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Mobile No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>9638869115</Col>
                </Row>
              </Col>
            </Row>
            <hr></hr>
            <Row className="mt-4">
              <Col>
                <div className="table-responsive ">
                  <div className="dataTables_wrapper no-footer">
                    <table className="table verticle-middle table-responsive-md mb-3">
                      <thead className="thead-light">
                        <tr role="row">
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Service Name: activate to sort column ascending"
                            style={{ width: "35%", padding: "10px 20px" }}
                          >
                            Service Name
                          </th>
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Quantity: activate to sort column ascending"
                            style={{
                              width: "15%",
                              textAlign: "center",
                              padding: "10px 40px",
                            }}
                          >
                            Quantity
                          </th>{" "}
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Service Book Days: activate to sort column ascending"
                            style={{
                              width: "30%",
                              textAlign: "center",
                              padding: "10px 40px",
                            }}
                          >
                            Service Book Days
                          </th>
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Amount: activate to sort column ascending"
                            style={{
                              width: "20%",
                              textAlign: "right",
                              padding: "10px 40px",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr role="row" className="odd">
                          <td>Care Giver</td>
                          <td style={{ textAlign: "center" }}>1</td>
                          <td style={{ textAlign: "center" }}>5</td>
                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 500.00
                          </td>
                        </tr>
                        <tr role="row" className="even">
                          <td>Doctor Visit</td>
                          <td style={{ textAlign: "center" }}>1</td>
                          <td style={{ textAlign: "center" }}>5</td>
                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 5000.00
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <div className="table-responsive ">
                  <div className="dataTables_wrapper no-footer">
                    <table className="table verticle-middle table-responsive-md mb-3">
                      <thead className="thead-light">
                        <tr role="row">
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Equipment Name: activate to sort column ascending"
                            style={{ width: "35%", padding: "10px 20px" }}
                          >
                            Equipment Name
                          </th>
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Quantity: activate to sort column ascending"
                            style={{
                              width: "15%",
                              textAlign: "center",
                              padding: "10px 40px",
                            }}
                          >
                            Quantity
                          </th>{" "}
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Equipment Book Days: activate to sort column ascending"
                            style={{
                              width: "30%",
                              textAlign: "center",
                              padding: "10px 40px",
                            }}
                          >
                            Equipment Book Days
                          </th>
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Amount: activate to sort column ascending"
                            style={{
                              width: "20%",
                              textAlign: "right",
                              padding: "10px 40px",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr role="row" className="odd">
                          <td>Reclining Electric Wheelchair</td>
                          <td style={{ textAlign: "center" }}>1</td>
                          <td style={{ textAlign: "center" }}>5</td>
                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 500.00
                          </td>
                        </tr>
                        <tr role="row" className="even">
                          <td>Basic Electric Wheelchair</td>
                          <td style={{ textAlign: "center" }}>1</td>
                          <td style={{ textAlign: "center" }}>5</td>
                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 5000.00
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <div className="table-responsive ">
                  <div className="dataTables_wrapper no-footer">
                    <table className="table verticle-middle table-responsive-md mb-3">
                      <thead className="thead-light">
                        <tr role="row">
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Package Name: activate to sort column ascending"
                            style={{ width: "80%", padding: "10px 20px" }}
                          >
                            Package Name
                          </th>

                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Amount: activate to sort column ascending"
                            style={{
                              width: "20%",
                              textAlign: "right",
                              padding: "10px 40px",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr role="row" className="odd">
                          <td>Post Knee & Hip Replacement Package</td>

                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 25500.00
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className="mt-2">
              <Col>
                <div className="table-responsive ">
                  <div className="dataTables_wrapper no-footer">
                    <table className="table verticle-middle table-responsive-md mb-3">
                      <thead className="thead-light">
                        <tr role="row">
                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Health Checkup: activate to sort column ascending"
                            style={{ width: "80%", padding: "10px 20px" }}
                          >
                            Health Checkup
                          </th>

                          <th
                            className="sorting"
                            tabIndex={0}
                            aria-controls="example5"
                            rowSpan={1}
                            colSpan={1}
                            aria-label="Amount: activate to sort column ascending"
                            style={{
                              width: "20%",
                              textAlign: "right",
                              padding: "10px 40px",
                            }}
                          >
                            Amount
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr role="row" className="odd">
                          <td>Cardiac Stress Analysis</td>

                          <td style={{ textAlign: "right" }}>
                            <i class="fa fa-rupee"></i> 500.00
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            <hr></hr>
            <Row>
              <Col lg={4}></Col>
              <Col lg={8}>
                <Row style={{ textAlign: "right" }}>
                  <Col lg={9}>
                    <b>Gross Amount</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={2}>
                    <i class="fa fa-rupee"></i> 5000.00
                  </Col>
                  <br></br>
                </Row>
                <Row style={{ textAlign: "right" }}>
                  <Col lg={9}>
                    <b>Discount Amount</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={2}>
                    {" "}
                    <i class="fa fa-rupee"></i> 500.00
                  </Col>
                  <br></br>
                </Row>
                <Row style={{ textAlign: "right" }}>
                  <Col lg={9}>
                    <b>Net Amount</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={2}>
                    <i class="fa fa-rupee"></i> 55002.00
                  </Col>
                  <br></br>
                </Row>
                <hr style={{ marginLeft: "50%" }}></hr>
                <Row style={{ textAlign: "right" }}>
                  <Col lg={9}>
                    <b>Deposite Amount</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={2}>
                    <i class="fa fa-rupee"></i> 50.00
                  </Col>
                  <br></br>
                </Row>
                <Row style={{ textAlign: "right" }}>
                  <Col lg={9}>
                    <b>Advance Amount</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={2}>
                    <i class="fa fa-rupee"></i> 5.00
                  </Col>
                  <br></br>
                </Row>
              </Col>
            </Row>
            {/* <button className="btn mt-5 mr-2 btn-xs btn-light">
              Download PDF
            </button> */}
            <Row>
              <Col>
                <button
                  style={{ float: "right" }}
                  className="btn mt-5 mr-2 btn-xm btn-light"
                  onClick={() => {
                    setOrderDetailModal(false);
                  }}
                >
                  Close
                </button>
                <Button
                  style={{ float: "right" }}
                  className="btn mt-5 mr-2 btn-xm btn-primary"
                  variant="primary btn-rounded"
                  onClick={() => {
                    window.open(
                      "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf"
                    );
                  }}
                >
                  <span className="btn-icon-left" style={{ color: "#36C95F" }}>
                    <i className="fa fa-download color-light" />
                  </span>
                  Download PDF
                </Button>
              </Col>
            </Row>
          </div>
        </Modal>
        <Modal
          className="modal fade"
          show={patientDetailModel}
          onHide={setPatientDetailModal}
          size="lg"
        >
          <div className="modal-header">
            <h4 className="modal-title fs-20">Patient Detail</h4>
            <button
              type="button"
              className="btn close"
              onClick={() => setPatientDetailModal(false)}
            >
              <span>×</span>
            </button>
          </div>
          <div className="modal-body">
            <Row>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Patient No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>PT00000001</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Order No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>AMDOD00002</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Patient Name</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>Yana Suthar</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Client Name</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>Chayan Suthar</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Gender</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>Female</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Blood Group</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>A+</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Relation with Client</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>Sister</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Mobile No.</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>9638869115</Col>
                </Row>
              </Col>
              <Col lg={6}>
                <Row>
                  <Col lg={6}>
                    <b>Email ID</b>
                  </Col>
                  <Col lg={1}>:</Col>
                  <Col lg={5}>yana@gmail.com</Col>
                </Row>
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              onClick={() => setPatientDetailModal(false)}
              className="btn btn-xs btn-light"
            >
              {" "}
              <i className="flaticon-delete-1"></i> Close
            </button>
          </div>
        </Modal>
      </Spin>
    </Fragment>
  );
};

export default AddPackageSchedule;
